import React, { useEffect, useRef } from 'react';

import { DropdownOwnerships } from '../../../../../../shared/components/ui/atoms';

interface SomeoneElseCreditInfoProps {
  ownershipItems: any[];
  isCreditInfoLocked: boolean;
  ficoElementResolved: React.ReactNode;
  propertiesElementResolved: React.ReactNode;
  unlockCreditInfo: () => void;
  ownershipSelected?: any;
  loanOwner?: { isSet: boolean; element: React.ReactNode };
  values?: any;
}

export const SomeoneElseCreditInfo: React.FC<SomeoneElseCreditInfoProps> = ({
  ownershipItems,
  isCreditInfoLocked,
  ficoElementResolved,
  propertiesElementResolved,
  unlockCreditInfo,
  values,
}) => {
  const hasUnlockedRef = useRef(false);

  useEffect(() => {
    if (isCreditInfoLocked && !hasUnlockedRef.current) {
      unlockCreditInfo();
      hasUnlockedRef.current = true;
    }
  }, [isCreditInfoLocked, unlockCreditInfo]);

  const guarantorFirstName = values?.guarantorFirstName || '';
  const guarantorLastName = values?.guarantorLastName || '';

  return (
    <span data-testid="someone-else-credit-info">
      <DropdownOwnerships
        items={ownershipItems}
        disabled={isCreditInfoLocked}
        guarantorFirstName={guarantorFirstName}
        guarantorLastName={guarantorLastName}
      />{' '}
      has a FICO score of {ficoElementResolved} and has purchased/sold {propertiesElementResolved} in the past 36 months
    </span>
  );
};

